import axios from "axios";
import cookie from "react-cookies";
import {store} from "./store";
import {logout} from "../redux_actions/login.action";
import {isNull} from "../utils/utils";
import {ErrorMessage} from "../utils/const";

let isRefreshing = false
let requestsToRefresh = []

// Interceptor handling refresh token logic
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;
        if (originalRequest && originalRequest.url === "/server/refresh/" && error.response
            && error.response.status === 400) {
            localStorage.setItem("showLogoutMessage", "true")
            store.dispatch(logout("You", "have been logged out due to inactivity"));
            return Promise.reject(error);
        }
        if (error.response && error.response.status === 440 && !originalRequest._retry) {
            if (!isRefreshing) {
                isRefreshing = true
                originalRequest._retry = true;
                // Dispatch an action to handle token refresh
                axios.post('/server/refresh/', {
                        refresh_token: localStorage.getItem('refresh_token')
                    }, {
                        headers: {'Content-Type': 'application/json'}
                    }).then(response => {
                    cookie.save('token', response.data.access_token, {path: '/'});
                    localStorage.setItem('refresh_token', response.data.refresh_token);
                    originalRequest.headers.Authorization = "Token " + response.data.access_token
                    requestsToRefresh.forEach((cb) => cb(response.data.access_token));

                }).catch(() => {
                    requestsToRefresh.forEach((cb) => cb(null))
                }).finally(() => {
                    requestsToRefresh = []
                    isRefreshing = false
                })
            }


            return new Promise((resolve, reject) => {
                requestsToRefresh.push((token) => {
                    if (token) {
                        originalRequest.headers.Authorization = 'Token ' + token
                        resolve(axios(originalRequest))
                    } else if (isNull(originalRequest.data)) {
                        originalRequest.data = {};
                        originalRequest.data.status = 440;
                        originalRequest.data.message = ErrorMessage.TOKEN_EXPIRED_ERROR;
                    }
                    reject(originalRequest)
                })
            })


        }
        return Promise.reject(error);
    }
);



